export default "__VITE_ASSET__fRCysf6z__"